
import { sendPasswordReminder } from '../../requests/loader';

const attempts = { num: 0, maxReached: false };
let attemptsReferenceTime = 0;
const intervalAttempts = 60 * 60 * 1000; // 1 hora en segundos
const sendReminder = async (email) => {
  // Response to return
  const response = {
    success: false,
    response: {}
  };
  return new Promise((resolve) => {
    sendPasswordReminder({ email }).then((result) => {
      if (result && result.status === '0') {
        response.success = true;
        response.data = result.response;
      }
      else {
        response.response = result;
      }
      resolve(response);
    }).catch((error) => {
      response.response = error;
      resolve(response);
    });
  });
};

const getAttempts = () => {
  const now = new Date().getTime();
  if ((now - attemptsReferenceTime) > intervalAttempts) {
    attempts.num = 0;
    attempts.maxReached = false;
    attemptsReferenceTime = 0;
  }
  return attempts;
};

const addAttempts = () => {
  if (attemptsReferenceTime === 0) {
    attempts.num = 1;
    attempts.maxReached = false;
    attemptsReferenceTime = new Date().getTime();
    return attempts;
  }
  else {
    const now = new Date().getTime();
    if ((now - attemptsReferenceTime) > intervalAttempts) {
      attempts.num = 1;
      attempts.maxReached = false;
      attemptsReferenceTime = new Date().getTime();
    }
    else {
      attempts.num = attempts.num + 1;
      attempts.maxReached = attempts.num >= 5;
    }
    return attempts;
  }
};

/**
 * Main export
 */
export const password = {
  sendReminder,
  getAttempts,
  addAttempts
};



// WEBPACK FOOTER //
// ./src/AAF/Auth/password.js